// extracted by mini-css-extract-plugin
export default {"box":"MyAddressSearch_box__ddzT5","input":"MyAddressSearch_input__JVwUQ","icon":"MyAddressSearch_icon__-VkJJ"};